import styled from "styled-components";

export const HeaderWrapper = styled.div<{
  show: boolean;
}>`
  position: fixed;
  z-index: 10;
  left: 50%;
  transform: translateX(-50%);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  background: ${(props) => (props.show ? "#0e0d2b" : "#fff")};
  font-size: 16px;
  font-weight: 600;
  top: 0;
  width: 100%;
  max-height: 48px;

  > .button {
    border-radius: 14px;
    background: #7f25fb;
    display: flex;
    width: auto;
    height: 36px;
    padding: 0 12px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    color: #fff;
    margin-right: 20px;
  }
`;

export const HeaderTitle = styled.div<{
  show: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-left: 20px;

  > img {
    cursor: pointer;
    width: 24px;
    height: 24px;
  }

  > .name {
    color: ${(props) => (props.show ? "#fff" : "#444444")};
    transition: all 0.1s ease-in-out;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;
